var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 629 451",
    width: 629,
    height: 451,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.564 440.814c-81.597-92.27-128.892-213.44-133.4-339.814H-70.964c2.62 184.42 149.94 333.835 333.53 339.814zm22.872 0c183.588-5.98 330.91-155.395 333.53-339.814h-200.12c-4.517 126.374-51.812 247.544-133.4 339.814zM408.84 101H139.16c4.586 125.98 52.455 246.642 134.84 337.597C356.384 347.642 404.253 226.98 408.84 101zM262.564-248.814C78.976-242.835-68.345-93.42-70.965 91h200.12c4.517-126.374 51.812-247.544 133.4-339.814zm22.872 0c81.597 92.27 128.892 213.44 133.4 339.814h200.12c-2.62-184.42-149.94-333.835-333.53-339.814zM408.84 91C404.253-34.98 356.384-155.642 274-246.597 191.616-155.642 143.747-34.98 139.16 91H408.84zM274 451C77.94 451-81 292.06-81 96S77.94-259 274-259 629-100.06 629 96 470.06 451 274 451z"
  })));
}

export default __webpack_public_path__ + "media/5c839acc.svg";
export { SvgGlobe as ReactComponent };